import React from 'react';

import { GetColorPallettes } from '../../components/UniversalMethods';
import PalletteThumbnail from '../../components/PalletteThumbnail/PalletteThumbnail';

import './Home.css';


class Home extends React.Component {

    constructor(props){
        super(props);

        this.timer = '';
        this.transitionChecker = false;
        this.state = {
            transition:''
        };
    }
    colorCallback = (color) => {
        if(this.transitionChecker) return;
        this.transitionChecker = true;

        this.setState({
            transition: color
        })
        
        this.timer = setTimeout(() => {
            this.props.history.push("../hex/" + color);
            clearTimeout(this.timer);
        }, 400);
        
    }

    render(){

        return (
            <div className='home-container' style={{backgroundColor: '#' + this.props.baseColors.background}}>
                <div className='home-content'>
                
                    <h1 style={{color: '#' + this.props.baseColors.highlightText}}>HEX i HUE</h1>
                    <div className='pallette-thumbnail-container'>
                        {GetColorPallettes().map(pallettes => <PalletteThumbnail colors={pallettes.colors} transition={this.state.transition} colorCallback = {this.colorCallback} textColor={this.props.baseColors.text}/>)}
                    </div>
                </div>
            </div>
        )
    }
}

export default Home;